import { forwardRef, type ButtonHTMLAttributes } from 'react';

type DsButtonVariant = 'default' | 'primary' | 'ghost';
type DsButtonSize = 'default' | 'small';

interface DsButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: DsButtonVariant;
  size?: DsButtonSize;
}

export const DsButton = forwardRef<HTMLButtonElement, DsButtonProps>(
  ({ variant = 'default', size = 'default', className = '', ...props }, ref) => {
    const classes = [
      'ds-btn',
      variant !== 'default' && variant,
      size !== 'default' && size,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return <button ref={ref} className={classes} {...props} />;
  },
);
